import React,
{
  useEffect,
  useState,
} from "react";

import AdminLayout
  from "./AdminLayout";

const AdminSchoolHouse = () => {

  const [title, setTitle] =
    useState("");

  const [houseName,
    setHouseName
  ] = useState("");

  const [file, setFile] =
    useState(null);

  const [data, setData] =
    useState([]);


  const fetchData = async () => {

    const res = await fetch(
      "https://stjosephweb.ilakshyaerp.in/api/school-house/all"
    );

    const result =
      await res.json();

    setData(result);

  };


  useEffect(() => {

    fetchData();

  }, []);


  const handleSubmit =
    async () => {

      const formData =
        new FormData();

      formData.append(
        "title",
        title
      );

      formData.append(
        "houseName",
        houseName
      );

      formData.append(
        "file",
        file
      );

      const res = await fetch(
        "https://stjosephweb.ilakshyaerp.in/api/school-house/add",
        {
          method: "POST",
          body: formData,
        }
      );

      const data =
        await res.json();

      alert(data.message);

      fetchData();

    };


  const handleDelete =
    async (id) => {

      const res = await fetch(
        `https://stjosephweb.ilakshyaerp.in/api/school-house/delete/${id}`,
        {
          method: "PUT",
        }
      );

      const data =
        await res.json();

      alert(data.message);

      fetchData();

    };


  return (

    <AdminLayout>

      <div className="p-10">

        <div className="bg-white p-6 rounded-xl shadow-md">

          <h2 className="text-2xl font-bold mb-5">

            Upload School House

          </h2>

          <input
            type="text"
            placeholder="Title"
            className="border p-3 w-full mb-4"
            onChange={(e) =>
              setTitle(e.target.value)
            }
          />

          <select
            className="border p-3 w-full mb-4"
            onChange={(e) =>
              setHouseName(e.target.value)
            }
          >

            <option value="">
              Select House
            </option>

            <option value="saffron">
              Saffron House
            </option>

            <option value="white">
              White House
            </option>

            <option value="green">
              Green House
            </option>

            <option value="blue">
              Blue House
            </option>

            <option value="maroon">
              Maroon House
            </option>

            <option value="yellow">
              Yellow House
            </option>

          </select>

          <input
            type="file"
            className="mb-4"
            onChange={(e) =>
              setFile(e.target.files[0])
            }
          />

          <button
            onClick={handleSubmit}
            className="bg-blue-900 text-white px-6 py-3 rounded-lg"
          >
            Upload
          </button>

        </div>


        <div className="mt-10 overflow-auto">

          <table className="w-full bg-white shadow rounded-xl">

            <thead className="bg-blue-900 text-white">

              <tr>

                <th className="p-4">
                  House
                </th>

                <th className="p-4">
                  Title
                </th>

                <th className="p-4">
                  File
                </th>

                <th className="p-4">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {
                data.map((item) => (

                  <tr
                    key={item.id}
                    className="border-b"
                  >

                    <td className="p-4 capitalize">
                      {item.houseName}
                    </td>

                    <td className="p-4">
                      {item.title}
                    </td>

                    <td className="p-4">

                      {
                        item.type === "image"
                          ? (
                            <img
                              src={`https://stjosephweb.ilakshyaerp.in/uploads/school-house/${item.file}`}
                              alt=""
                              className="w-28 border"
                            />
                          )
                          : (
                            <a
                              href={`https://stjosephweb.ilakshyaerp.in/uploads/school-house/${item.file}`}
                              target="_blank"
                              rel="noreferrer"
                              className="text-blue-700"
                            >
                              View PDF
                            </a>
                          )
                      }

                    </td>

                    <td className="p-4">

                      <button
                        onClick={() =>
                          handleDelete(item.id)
                        }
                        className="bg-red-600 text-white px-4 py-2 rounded"
                      >
                        Delete
                      </button>

                    </td>

                  </tr>

                ))
              }

            </tbody>

          </table>

        </div>

      </div>

    </AdminLayout>
  );
};

export default AdminSchoolHouse;